import React from "react";
import { DLQItem } from "../../lusca-search-api/generated-src";
import { AsyncActionButton, asyncStatusMap } from "../common/AsyncActionButton";
import { DlqRedriveResult } from "../../hooks/useFetchDlqRedriveInfo";

interface DlqRedriveStatusIndicatorProps {
  dlqItem: DLQItem;
  redriveResult?: DlqRedriveResult;
  onRequeue: () => void;
}

const DlqRedriveStatusIndicator: React.FC<DlqRedriveStatusIndicatorProps> = ({
  dlqItem,
  redriveResult,
  onRequeue,
}) => {
  const { status, error } = redriveResult || { status: "unknown", error: undefined };

  return (
    <AsyncActionButton
      label="Requeue Message"
      successLabel="Requeue Successful"
      failedLabel="Requeue Failed"
      status={asyncStatusMap[status]}
      onClick={onRequeue}
      errorMessage={error}
    />
  );
};

export default DlqRedriveStatusIndicator;
